import { ActionDelegate } from 'containers/Base/ActionDelegate';
import { Environment } from 'data/terra/Environment';
import { Market } from 'data/terra/Market';
import { Platform } from 'data/terra/Platform';
import { Service } from 'data/terra/Service';
import { UserRole } from 'data/terra/UserRole';
import { Module } from 'data/terra/Module';
import { fetchEnvironmentsDelegate } from './actions/FetchEnvironments';
import { fetchMarketsDelegate } from './actions/FetchMarkets';
import { fetchPlatformsDelegate } from './actions/FetchPlatforms';
import { fetchServicesDelegate } from './actions/FetchServices';
import { fetchUserRolesDelegate } from './actions/FetchUserRoles';
import { CommonAction } from './actionTypes';
import { fetchModulesDelegate } from './actions/FetchModules';
import { UndefinedAble } from 'data/base';

export interface CommonState {
  platforms: Platform[];
  markets: Market[];
  environments: Environment[];
  userRoles: UserRole[];
  services: Service[];
  modules: Module[];
  platformError: UndefinedAble<string>;
  marketError: UndefinedAble<string>;
  environmentError: UndefinedAble<string>;
}

const initialState: CommonState = {
  platforms: [],
  markets: [],
  environments: [],
  userRoles: [],
  services: [],
  modules: [],
  platformError: undefined,
  marketError: undefined,
  environmentError: undefined,
};

const delegates: {
  [key: string]: ActionDelegate<any, CommonState>;
} = {
  ...fetchPlatformsDelegate,
  ...fetchMarketsDelegate,
  ...fetchEnvironmentsDelegate,
  ...fetchUserRolesDelegate,
  ...fetchServicesDelegate,
  ...fetchModulesDelegate,
};

export default function reduce(
  state: CommonState = initialState,
  action: CommonAction
): CommonState {
  const delegate = delegates[action.type];
  if (delegate) {
    return delegate(state, action);
  } else {
    return state;
  }
}
